import React from "react";
import { styled, Box, BoxProps, Typography } from "@material-ui/core";

const BoxCell = styled(Box)(({ theme }) => ({
  flex: "0 0",
  whiteSpace: "nowrap",
}));

export const PageHeader: React.FC<
  {
    title: string;
  } & BoxProps
> = ({ title, children, ...props }) => (
  <BoxCell {...props}>
    <Typography variant="body1" color="textPrimary">
      {title}
    </Typography>
    {children}
  </BoxCell>
);
